import i18n from '@/i18n'

import { asyncToast } from '../ui/sonner'

export const fileUploadToast = async (upload: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(upload, {
    error: () => [t('asyncToasts.uploadFile.error')],
    loading: () => [t('asyncToasts.uploadFile.loading')],
    success: () => [t('asyncToasts.uploadFile.success')],
  })
}

export const fileDeleteToast = async (deletion: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(deletion, {
    error: () => [t('asyncToasts.deleteFile.error')],
    loading: () => [t('asyncToasts.deleteFile.loading')],
    success: () => [t('asyncToasts.deleteFile.success')],
  })
}

export const errandDeleteToast = async (deletion: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(deletion, {
    error: () => [t('asyncToasts.deleteErrand.error')],
    loading: () => [t('asyncToasts.deleteErrand.loading')],
    success: () => [t('asyncToasts.deleteErrand.success')],
  })
}

export const noteDeleteToast = async (deletion: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(deletion, {
    error: () => [t('asyncToasts.deleteNote.error')],
    loading: () => [t('asyncToasts.deleteNote.loading')],
    success: () => [t('asyncToasts.deleteNote.success')],
  })
}

export const threadDeleteToast = async (deletion: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(deletion, {
    error: () => [t('asyncToasts.deleteThread.error')],
    loading: () => [t('asyncToasts.deleteThread.loading')],
    success: () => [t('asyncToasts.deleteThread.success')],
  })
}

export const revokeIndividualAccessToast = async (deletion: Promise<unknown>) => {
  const t = i18n.t

  return asyncToast(deletion, {
    error: () => [t('asyncToasts.revokeIndividualAccess.error')],
    loading: () => [t('asyncToasts.revokeIndividualAccess.loading')],
    success: () => [t('asyncToasts.revokeIndividualAccess.success')],
  })
}
